import React from "react";
import PropTypes from "prop-types";
import {Edit as EditIcon} from "@material-ui/icons";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import MarkerCategoryModal from "../../../MarkerCategoryModal";
import LinkMenuItem from "../../components/LinkMenuItem";
import MenuHeader from "../../components/MenuHeader";
import MenuBackButton from "../../components/MenuBackButton";
import {MarkerTypeCategoryRecord} from "../../../../feathers/records";
import "./style.scss";

export default class MarkerCategoriesMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentlyEditing: null
    };
  }

  render() {
    return (
      <React.Fragment>
        <MenuBackButton to={`/marker-settings?facilityId=${this.props.location.query.facilityId}`} />
        <List>
          <MenuHeader>Marker Categories</MenuHeader>
          <Button
            className="addMarkerCategoryButton"
            color="secondary"
            variant="contained"
            onClick={() => this.handleOpenModal(new MarkerTypeCategoryRecord())}>
            New Category
          </Button>
          {this.renderCategoryList()}
        </List>
        {this.renderEditModal()}
      </React.Fragment>
    );
  }

  handleOpenModal = markerCategory => {
    this.setState({currentlyEditing: markerCategory});
  };

  renderCategoryList() {
    if (this.props.categories.size > 0) {
      return <List className="markerList">{this.renderCategories()}</List>;
    }
  }

  renderCategories() {
    const {markerTypes, categories} = this.props;
    return categories.map(category => {
      return (
        <React.Fragment key={category._id}>
          <LinkMenuItem
            onClick={() => this.handleOpenModal(category)}
            primary={<p className="menuItemText">{category.name}</p>}
            secondary={`${this.countMarkerTypes(markerTypes, category._id)} marker types in this category`}
            iconRight={<EditIcon />}
          />
          <Divider />
        </React.Fragment>
      );
    });
  }

  renderEditModal() {
    if (this.state.currentlyEditing) {
      return (
        <MarkerCategoryModal markerCategory={this.state.currentlyEditing} onRequestClose={this.handleCloseModal} />
      );
    }
  }

  handleCloseModal = () => {
    this.setState({currentlyEditing: null});
  };

  countMarkerTypes(markerTypes, id) {
    return markerTypes.filter(markerType => markerType.category_id === id).size;
  }
}

MarkerCategoriesMenu.propTypes = {
  location: PropTypes.object.isRequired,
  markerTypes: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menus/MarkerCategoriesMenu/index.jsx